import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#4A148C',
    secondary: '#7E57C2',
    background: {
      main: '#121212',
      paper: '#1E1E1E',
      sidebar: '#1A1625',
      card: '#242424'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B3B3B3',
      disabled: '#666666',
      light: '#F5F5F5',
      dark: '#333333'
    },
    action: {
      active: '#7E57C2',
      hover: '#5E35B1'
    },
    success: '#34C759',
    error: '#FF3B30',
    errorLight: '#FFEBEE',
    warning: '#FFCC00',
    info: '#007AFF',
    primaryDark: '#311B92',
    backgroundDark: '#0A0A0A',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px'
  },
  sizes: {
    sidebar: {
      expanded: '260px',
      collapsed: '80px'
    },
    header: {
      height: '64px'
    }
  },
  typography: {
    h1: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: 1.2
    },
    h2: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.3
    },
    body: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5
    },
    small: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.4
    },
    fontSize: {
      small: '14px',
      medium: '16px',
      large: '18px',
      xlarge: '20px'
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    }
  },
  zIndex: {
    header: 1000,
    sidebar: 1000,
    modal: 1100
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%'
  }
};

export type Theme = typeof theme;
